import renderExitGameScene from '@/lib/services/ui/scenes/exit-game-scene/render-exit-game-scene.js';

const exitGameScene = (canvas, state) => {
  // ======== 游戏模式选择场景渲染入口 ========
  renderExitGameScene(canvas, state);
};

export default exitGameScene;
